module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive-selected/cyclebar-ff367c6eb2836a61f63ac37a431c304e.png";